/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

// When adding new locale here update package.json file in compiler package
// and run "yarn plurals" command there.
var SupportedLocales;
(function (SupportedLocales) {
    SupportedLocales["en-gb"] = "en-gb";
    SupportedLocales["en-us"] = "en-us";
    SupportedLocales["de"] = "de";
    SupportedLocales["nl"] = "nl";
    SupportedLocales["fr"] = "fr";
    SupportedLocales["es"] = "es";
    SupportedLocales["es-ar"] = "es-ar";
    SupportedLocales["es-mx"] = "es-mx";
    SupportedLocales["ca"] = "ca";
    SupportedLocales["it"] = "it";
    SupportedLocales["pt-pt"] = "pt-pt";
    SupportedLocales["pt-br"] = "pt-br";
    SupportedLocales["no"] = "no";
    SupportedLocales["fi"] = "fi";
    SupportedLocales["sv"] = "sv";
    SupportedLocales["da"] = "da";
    SupportedLocales["cs"] = "cs";
    SupportedLocales["hu"] = "hu";
    SupportedLocales["ro"] = "ro";
    SupportedLocales["ja"] = "ja";
    SupportedLocales["zh-cn"] = "zh-cn";
    SupportedLocales["zh-tw"] = "zh-tw";
    SupportedLocales["pl"] = "pl";
    SupportedLocales["el"] = "el";
    SupportedLocales["ru"] = "ru";
    SupportedLocales["tr"] = "tr";
    SupportedLocales["bg"] = "bg";
    SupportedLocales["ar"] = "ar";
    SupportedLocales["ka"] = "ka";
    SupportedLocales["ko"] = "ko";
    SupportedLocales["he"] = "he";
    SupportedLocales["lv"] = "lv";
    SupportedLocales["uk"] = "uk";
    SupportedLocales["id"] = "id";
    SupportedLocales["ms"] = "ms";
    SupportedLocales["th"] = "th";
    SupportedLocales["et"] = "et";
    SupportedLocales["hr"] = "hr";
    SupportedLocales["lt"] = "lt";
    SupportedLocales["sk"] = "sk";
    SupportedLocales["sr"] = "sr";
    SupportedLocales["sl"] = "sl";
    SupportedLocales["vi"] = "vi";
    SupportedLocales["tl"] = "tl";
    SupportedLocales["is"] = "is";
    SupportedLocales["hi"] = "hi";
})(SupportedLocales || (SupportedLocales = {}));
var locales = Object.keys(SupportedLocales);
var localeToBookingLangCode = __assign(__assign({}, SupportedLocales), { 'en-us': 'xu', 'en-gb': 'en', 'es-ar': 'xa', 'pt-br': 'xb', 'pt-pt': 'pt', 'zh-tw': 'xt', 'zh-cn': 'zh', 'es-mx': 'xm' });

export { SupportedLocales, locales, localeToBookingLangCode };
//# sourceMappingURL=index.es.js.map
